import React, { useEffect, useState } from "react";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { useLocation, useNavigate } from "react-router-dom";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import moment from "moment";
import Select from 'react-select';
import { ConvertErrorArrayToString } from "../../Services/Common";
import { setToastData } from "../../Store/reducers/Toast";
const customMultiSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        maxHeight: '100px', // Keeps the height fixed even when selecting all
        overflowY: 'auto',
    }),
    menu: (provided) => ({
        ...provided,
        maxHeight: '200px', // Dropdown max height
        overflowY: 'auto' // Enables scrolling inside dropdown
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: '200px',
        overflowY: 'auto' // Allows scrolling in options
    }),
};
const DutyChart = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [eventData, setEventData] = useState({});
    const { accessToken } = useSelector(state => state.user);
    useEffect(() => {
        if (!location.state?.event_id || location.state?.event_id < 1) {
            //navigate('/events');
        }
        else {
            dispatch(setPageTitle('Duty Chart'));
            dispatch(setMainLoading(true));
            PostAxios(`event/get-event-duty-chart-by-id`, { event_id: location.state.event_id }, accessToken)
                .then(({ data }) => {
                    if (data.status === "1") {
                        let memList = [];
                        for (let i of data.membersList) {
                            let label = data.data.event_user_div !== "all" && parseInt(data.data.event_user_div) > 0 ? '' : `(${i.division_name})`;
                            memList.push({
                                value: i.user_id,
                                label: `${i.full_name} ${label}`
                            })
                        }
                        setEventData({ ...data.data, membersList: memList, duty_chart: data.duty_chart });
                    }
                    else {
                        // navigate('/events');
                    }
                })
                .catch(err => {
                    responseCatchFunc(dispatch, err);
                }).finally(() => {
                    dispatch(setMainLoading(false));
                })
        }
    }, [accessToken, dispatch, location]);
    const exportDutyChart = () => {
        dispatch(setMainLoading(true));
        let form_data = new FormData();
        form_data.append('event_id', eventData?.ID);
        form_data.append('duty_id', eventData?.duty_chart?.id);
        form_data.append('token', accessToken);
        fetch(`${process.env.REACT_APP_API_URL}event/export-duty-chart`, {
            method: 'POST',
            body: form_data,
            mode: 'cors',
        })
        /*.then(response => {
            console.log(response);
        })*/
        
            .then(response => {
                // Get the blob from the response
                const blob = response.blob();
                const headers = response.headers;
                return Promise.all([blob, headers]);
            })
            .then(([blob, headers]) => {
                const contentDisposition = headers.get('Content-Disposition');
                let fileName = `event-duty-chart-${moment().format('YYYY-MM-DD-HH:mm:ss')}.xlsx`;
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = fileName;//`event-attendance-report-${moment().format('YYYY-MM-DD-HH:mm:ss')}.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            })
            .catch(error => responseCatchFunc(dispatch, error))
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const sendDutyNotification = () => {
        dispatch(setMainLoading(true));
        PostAxios(`cron/add-job`, {
            'type' :'event_duty_notification',
            'type_id': eventData.ID
        }, accessToken)
        .then(({data})=>{
            if (data.status === "1") {
                dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }))
            }
            else {
                dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
            }
        })
        .catch(err=>{
            responseCatchFunc(dispatch,err);
        })
        .finally(()=>{
            dispatch(setMainLoading(false));
        })
    }
    if (typeof eventData.event_title !== "undefined") {
        return (
            <div className="main-form-sec">
                {
                    typeof eventData?.duty_chart?.id !== "undefined" && parseInt(eventData?.duty_chart?.id) > 0 &&
                    <div className="w-100 mb-4 text-end">
                        {
                            (moment(`${eventData.event_end_date} ${eventData.event_end_time}`) >= moment()) &&
                            <button className="btn btn-blue me-2" onClick={() => { sendDutyNotification() }}>Send Duty Notification</button>

                        }
                        <button className="btn btn-blue" onClick={() => { exportDutyChart() }}>Export Duty Chart</button>
                    </div>
                }
                <Formik
                    initialValues={{
                        project_incharge: eventData?.duty_chart?.project_incharge || "",
                        duties: eventData?.duty_chart?.duties || [{ task: "", job_description: "", incharge: 0, supporting: [],members:[] }],
                        important_notes: eventData?.duty_chart?.important_notes || "",
                    }}
                    validate={values => {
                        const errors = {};
                        // if (!values.project_incharge && values.project_incharge < 1) { errors.project_incharge = "Please choose Project Incharge"; }
                        if (!values.important_notes) { errors.important_notes = "Please enter notes"; }
                        return errors;
                    }}
                    onSubmit={(values) => {
                        dispatch(setMainLoading(true));
                        let payLoad = { ...values, event_id: eventData.ID };
                        if (typeof eventData?.duty_chart?.id !== "undefined" && parseInt(eventData?.duty_chart?.id) > 0) {
                            payLoad.duty_id = eventData?.duty_chart?.id;
                        }
                        PostAxios(`event/save-duty-chart`, payLoad, accessToken)
                            .then(({ data }) => {
                                if (data.status === "1") {
                                    dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }))
                                    navigate('/events');
                                }
                                else {
                                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                                }
                            })
                            .catch(err => {
                                responseCatchFunc(dispatch, err);
                            }).finally(() => {
                                dispatch(setMainLoading(false));
                            })
                    }}
                >
                    {({ values, errors, touched, setFieldValue }) => (
                        <Form>
                            <div className="form-sec">
                                <div className={`form-field-group w-100`}>
                                    <div className="w-100 input-area">
                                        <input type="text" readOnly value={eventData.event_title.toUpperCase()} className="form-input text-center" />
                                    </div>
                                </div>
                                {
                                    eventData.event_user_div !== "all" && parseInt(eventData.event_user_div) > 0 &&
                                    <div className={`form-field-group w-100`}>
                                        <div className="w-100 input-area">
                                            <input type="text" readOnly value={eventData.division_name.toUpperCase()} className="form-input text-center" />
                                        </div>
                                    </div>
                                }
                                <div className={`form-field-group w-100 ${(errors.project_incharge && touched.project_incharge) ? 'error-input' : ''}`}>
                                    <div className="w-25">
                                        <label htmlFor="event_location">Project Incharge</label>
                                    </div>
                                    <div className="w-75 input-area text-left">
                                        <input type="text" readOnly value={eventData.event_incharge_name.toUpperCase()} className="form-input text-left" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-100`}>
                                    <div className="w-100 input-area">
                                        <input type="text" readOnly value={eventData.event_incharge_name.toUpperCase()} className="form-input text-center" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-100`}>
                                    <div className="w-100 input-area">
                                        <input type="text" readOnly value={`${moment(`${eventData.event_start_date}`).format("DD MMMM YYYY").toUpperCase()} - ${moment(`${eventData.event_start_date}`).format("dddd").toUpperCase()}`} className="form-input text-center" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-100`}>
                                    <div className="w-100 input-area">
                                        <input type="text" readOnly value={`REPORTING TIME: ${moment(`${eventData.event_start_date} ${eventData?.event_start_time}`).format("h:mm a")} @ ${eventData.event_location}`} className="form-input text-center" />
                                    </div>
                                </div>
                                <div style={{paddingLeft:'10px',paddingRight:'10px', overflow: 'hidden', width: '100%'}}>
                                    <div className="divider"></div>
                                    <FieldArray name="duties">
                                        {({ push, remove }) => (
                                            <div className="table-wrapper" style={{ overflow: 'auto'}}>
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>SR No.</th>
                                                            <th style={{ minWidth: '80px',minWidth: '150px' }}>Task</th>
                                                            <th style={{ minWidth: '80px',minWidth: '150px' }}>Job Description</th>
                                                            <th style={{ maxWidth: '300px',minWidth: '250px' }}>Incharge</th>
                                                            <th style={{ maxWidth: '300px',minWidth: '250px' }}>Assistant</th>
                                                            <th style={{ maxWidth: '300px',minWidth: '250px' }}>Members</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {values.duties.map((_, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>
                                                                    <div className={`form-field-group w-100 mb-0`}>
                                                                        <div className="w-100 input-area">
                                                                            <Field name={`duties.${index}.task`} placeholder="Task" className="form-input" />
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className={`form-field-group w-100 mb-0`}>
                                                                        <div className="w-100 input-area">
                                                                            <Field name={`duties.${index}.job_description`} placeholder="Job Description" as="textarea" className="form-input form-textarea" rows="3" />
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td style={{ maxWidth: '300px',minWidth: '250px' }}>
                                                                    <Select
                                                                        options={eventData.membersList || []}
                                                                        placeholder="Choose Incharge"
                                                                        value={values.duties[index].incharge}
                                                                        onChange={(values) => {
                                                                            setFieldValue(`duties.${index}.incharge`, values);
                                                                        }}
                                                                        styles={customMultiSelectStyles}
                                                                        isSearchable={true}
                                                                        isMulti={false}
                                                                        isClearable
                                                                        menuPortalTarget={document.body}
                                                                    />
                                                                </td>
                                                                <td style={{ maxWidth: '300px',minWidth: '250px' }}>
                                                                    <Select
                                                                        styles={customMultiSelectStyles}
                                                                        options={[{ label: 'Select All', value: 'select_all' }, ...(eventData.membersList || [])]}
                                                                        placeholder="Choose Supporting"
                                                                        value={values.duties[index].supporting}
                                                                        onChange={(selectedValues) => {
                                                                            if (selectedValues.some((option) => option.value === 'select_all')) {
                                                                                const allMembers = eventData.membersList;
                                                                                setFieldValue(`duties.${index}.supporting`, allMembers);
                                                                            } else {
                                                                                setFieldValue(`duties.${index}.supporting`, selectedValues);
                                                                            }
                                                                        }}
                                                                        isSearchable
                                                                        isMulti
                                                                        isClearable
                                                                        menuPortalTarget={document.body}
                                                                    />
                                                                </td>
                                                                <td style={{ maxWidth: '300px',minWidth: '250px' }}>
                                                                    <Select
                                                                        styles={customMultiSelectStyles}
                                                                        options={[{ label: 'Select All', value: 'select_all' }, ...(eventData.membersList || [])]}
                                                                        placeholder="Choose Members"
                                                                        value={values.duties[index].members}
                                                                        onChange={(selectedValues) => {
                                                                            if (selectedValues.some((option) => option.value === 'select_all')) {
                                                                                const allMembers = eventData.membersList;
                                                                                setFieldValue(`duties.${index}.members`, allMembers);
                                                                            } else {
                                                                                setFieldValue(`duties.${index}.members`, selectedValues);
                                                                            }
                                                                        }}
                                                                        isSearchable
                                                                        isMulti
                                                                        isClearable
                                                                        menuPortalTarget={document.body}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {
                                                                        (values.duties.length - 1) == index &&
                                                                        <button type="button" className="add-icon" onClick={() => push({ task: "", job_description: "", incharge: 0, supporting: [],members:[] })}>
                                                                            <i className="fa-solid fa-circle-plus" style={{ fontSize: 'inherit' }}></i>
                                                                        </button>
                                                                    }
                                                                    {
                                                                        values.duties.length > 1 &&
                                                                        <button type="button" className="remove-icon" onClick={() => remove(index)}>
                                                                            <i className="fa-solid fa-circle-xmark" style={{ fontSize: 'inherit' }}></i>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}

                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </FieldArray>
                                    <div className="divider"></div>
                                </div>
                                <h3 className="text-lg font-bold mt-6"></h3>
                                <div className={`form-field-group w-100 ${(errors.important_notes && touched.important_notes) ? 'error-input' : ''}`}>
                                    <div className="w-25">
                                        <label htmlFor="event_location">Important Notes*</label>
                                    </div>
                                    <div className="w-100 mt-2 input-area text-left">
                                        <Field name="important_notes" as="textarea" placeholder="Important Notes" className="form-input form-textarea" rows="10" />
                                        <ErrorMessage component="span" name="important_notes" className="error-label" />
                                        <small className="mt-3 d-block">*Each new line item will be considered as a separate point</small>
                                    </div>
                                </div>
                                {
                                    (moment(`${eventData.event_end_date} ${eventData.event_end_time}`) >= moment()) &&
                                    <div className="text-center w-100">
                                        <button type="submit" className="btn btn-blue">Save Duty Chart</button>
                                    </div>
                                }
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
    return null;
};

export default DutyChart;
